import { createWebHistory, createRouter } from "vue-router";
import { useAccountStore } from '@/stores';

import BuyNewProxyPage from "../pages/Customer/BuyNewProxyPage.vue";
import MyProxyPage from "../pages/Customer/MyProxyPage.vue";
import MyReferralPage from "../pages/Customer/ReferralPage.vue";
import BitcartPage from "../pages/Customer/BitcartPage.vue";
import AccountPage from "../pages/Customer/AccountPage.vue";
import ApikeyPage from "../pages/Customer/ApikeyPage.vue";
import AccountSettingPage from "../pages/Customer/AccountSettingPage.vue";
import AdminServerPage from "../pages/Admin/ServerPage.vue";
import AdminStockPage from "../pages/Admin/StockPage.vue";
import AdminProxyPage from "../pages/Admin/ProxyPage.vue";
import AdminDisProxyPage from "../pages/Admin/DisProxyPage.vue";
import AdminLicensePage from "../pages/Admin/LicensePage.vue";
import AdminPackagePage from "../pages/Admin/PackagePage.vue";
import AdminCouponPage from "../pages/Admin/CouponPage.vue";
import AdminCustomerPage from "../pages/Admin/CustomerPage.vue";
import AdminTransactionPage from "../pages/Admin/TransactionPage.vue";
import AdminConfigurationPage from "../pages/Admin/ConfigurationPage.vue";
import AdminResellerPage from "../pages/Admin/ResellerPage.vue";
import AdminReferrerPage from "../pages/Admin/ReferrerPage.vue";
import AdminInvitedUsersPage from "../pages/Admin/InvitedUsersPage.vue";
import AdminMetaPage from "../pages/Admin/MetaPage.vue";
import AdminChat from "../pages/Admin/ChatPage.vue";
import AdminApikeyPage from "../pages/Admin/ApikeyPage.vue";
import AdminNewLocationPage from "../pages/Admin/NewLocationPage.vue";
import AdminStockAlertPage from "../pages/Admin/StockAlertPage.vue";
import AdminCountryPage from "../pages/Admin/CountryPage.vue";
import AdminIspPage from "../pages/Admin/IspPage.vue";
import AdminDeployPage from "../pages/Admin/DeployPage.vue";
import FAQPage from "../pages/FAQPage.vue";
import PartnersPage from "../pages/PartnersPage.vue";

import LoginPage from "../pages/Authentication/LoginPage.vue";
import RegisterPage from "../pages/Authentication/RegisterPage.vue";
import ForgotPasswordPage from "@/pages/Authentication/ForgotPasswordPage.vue";
import ResetPasswordPage from "@/pages/Authentication/ResetPasswordPage.vue";
const appName = process.env.VUE_APP_VUE_NAME;
const routes = [
  {
    path: "/buy-new-proxy",
    name: "BuyNewProxyPage",
    component: BuyNewProxyPage,
  },
  {
    path: "/my-proxy",
    name: "MyProxyPage",
    component: MyProxyPage,
  },
  {
    path: "/bitcart",
    name: "BitcartPage",
    component: BitcartPage,
  },
  {
    path: "/account",
    name: "AccountPage",
    component: AccountPage,
  },
  {
    path: "/referral",
    name: "MyReferralPage",
    component: MyReferralPage,
  },
  {
    path: "/apikey",
    name: "ApikeyPage",
    component: ApikeyPage,
  },
  {
    path: "/account-setting",
    name: "AccountSettingPage",
    component: AccountSettingPage,
  },
  {
    path: "/",
    name: "",
    component: BuyNewProxyPage,
  },
  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/register",
    name: "RegisterPage",
    component: RegisterPage,
  },
  {
    path: "/reset",
    name: "ResetPage",
    component: ResetPasswordPage,
  },
  {
    path: "/forgotpass",
    name: "ForgotPage",
    component: ForgotPasswordPage,
  },
  {
    path: "/admin/server",
    name: "AdminServerPage",
    component: AdminServerPage,
  },
  {
    path: "/admin/proxystock",
    name: "AdminStockPage",
    component: AdminStockPage,
  },
  {
    path: "/admin/proxy",
    name: "AdminProxyPage",
    component: AdminProxyPage,
  },
  {
    path: "/admin/disconnectedproxy",
    name: "Disconnected Proxy",
    component: AdminDisProxyPage,
  },
  {
    path: "/admin/license",
    name: "AdminLicensePage",
    component: AdminLicensePage,
  },
  {
    path: "/admin/package",
    name: "AdminPackagePage",
    component: AdminPackagePage,
  },
  {
    path: "/admin/coupon",
    name: "AdminCouponPage",
    component: AdminCouponPage,
  },
  {
    path: "/admin/customer",
    name: "AdminCustomerPage",
    component: AdminCustomerPage,
  },
  {
    path: "/admin/transaction",
    name: "AdminTransactionPage",
    component: AdminTransactionPage,
  },
  {
    path: "/admin/reseller",
    name: "AdminResellerPage",
    component: AdminResellerPage,
  },
  {
    path: "/admin/referrer",
    name: "AdminReferrerPage",
    component: AdminReferrerPage,
  },
  {
    path: "/admin/invitedusers",
    name: "AdminInvitedUsersPage",
    component: AdminInvitedUsersPage,
  },
  {
    path: "/admin/configuration",
    name: "AdminConfigurationPage",
    component: AdminConfigurationPage,
  },
  {
    path: "/admin/apikey",
    name: "AdminApikeyPage",
    component: AdminApikeyPage,
  },
  {
    path: "/admin/deploy",
    name: "AdminDeployPage",
    component: AdminDeployPage,
  },
  {
    path: "/faq",
    name: "FAQPage",
    component: FAQPage,
  },
  {
    path: "/partners",
    name: "PartnersPage",
    component: PartnersPage,
    beforeEnter: () => (process.env.VUE_APP_VUE_NAME === 'ausproxies' ? '/' : true),   // AusProxies: no partners page for now
  },
  {
    path: "/admin/chat",
    name: "AdminChat",
    component: AdminChat,
  },
  {
    // per-customer supplier amounts (admin only)
    path: "/admin/custom-pricing",
    name: "AdminCustomPricing",
    component: () => import("../pages/Admin/CustomPricingPage.vue"),
  },
  {
    // every change to licences, ports, servers, money, accounts and admin settings (admin only)
    path: "/admin/audit",
    name: "AdminAudit",
    component: () => import("../pages/Admin/AuditPage.vue"),
  },
  {
    // AusProxies Chat: the live chat as its own installable phone app (full screen, no dashboard menus)
    path: "/admin/livechat",
    name: "AdminLiveChatApp",
    component: () => import("../pages/Admin/LiveChatAppPage.vue"),
    meta: { bare: true },
  },
  {
    path: "/admin/siteinfo",
    name: "AdminMeta",
    component: AdminMetaPage,
  },
  {
    path: "/admin/stock-alerts",
    name: "AdminStockAlerts",
    component: AdminStockAlertPage,
  },
  {
    path: "/admin/new-location",
    name: "AdminNewLocation",
    component: AdminNewLocationPage,
  },
  {
    path: "/admin/country",
    name: "AdminCountry",
    component: AdminCountryPage,
  },
  {
    path: "/admin/isp",
    name: "AdminIsp",
    component: AdminIspPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes: routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

router.beforeEach(async (to) => {
  // clear alert on route change
  // const alertStore = useAlertStore();
  // alertStore.clear();
  // redirect to signin page if not logged in and trying to access a restricted page 
  const publicPages = ['/login', '/register', '/forgotpass', '/reset'];
  const guestOnlyPages = ['/login', '/register', '/forgotpass'];
  const isResetPage = to.path === '/reset';
  const authRequired = !publicPages.includes(to.path);
  const accountStore = useAccountStore();
  if (accountStore.user && !accountStore.user.accessToken) {
    accountStore.user = null;
    localStorage.removeItem('user');
  }
  // chat.ausproxies.au is the staff chat app: no sign-ups, and only admin sessions
  if (window.location.hostname.startsWith("chat.")) {
    if (to.path.startsWith("/register")) return '/login';
    if (accountStore.user && accountStore.user.role !== 'admin' && !isResetPage) {
      accountStore.user = null;
      localStorage.removeItem('user');
      return '/login';
    }
  }
  if (appName === 'proxywarehouse' && (to.path.startsWith("/register") || to.path.startsWith("/forgotpass"))) {
    return '/login';
  }
  // const alertStore = useAlertStore();
  // alert(authRequired+","+!accountStore.user)
  if (authRequired && (!accountStore.user)) {
    accountStore.returnUrl = to.fullPath;
    accountStore.route_name = ""
    return '/login';
  } else if (accountStore.user && !isResetPage) {
    if (accountStore.user.role !== 'admin') {
      if (to.path.startsWith("/admin")) {
        accountStore.route_name = ""
        return '/buy-new-proxy';
      }
      else if (guestOnlyPages.includes(to.path) || to.path === "/") {
        accountStore.route_name = "buy-new-proxy"
        return '/buy-new-proxy';
      }
    } else {
      if (window.location.hostname.startsWith("chat.") && !to.path.startsWith("/admin/livechat")) {
        return { path: "/admin/livechat", query: to.path === "/admin/chat" ? to.query : {} };
      }
      if (!to.path.startsWith("/admin") && !to.path.startsWith("/account") && !to.path.startsWith("/faq") && !to.path.startsWith("/partners")) {
        accountStore.route_name = "admin"
        return '/admin';
      }
    }
  }
  // set route name
  accountStore.route_name = to.path;
});

export default router;
